module.exports = __webpack_public_path__ + "img/10.a58e36d3.jpg";